import { Component, ElementRef, ViewChild } from '@angular/core';
import { CartService } from '../../finance/shared/services/cart.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ChannelService } from '../../shared/services/realtime-messaging/channel.service';
import { AppSettings } from '../../shared/settings/app-settings.model';
import { pluck } from 'rxjs/operators';
import { AuthService } from '../../auth/services/auth.service';

@Component({
    selector: 'cart-count',
    template: '{{cartCount}}'
})

export class CartRealtimeMessageComponent extends BaseComponent {
    public cartCount = '';
    @ViewChild('cookieFrame', { static: true }) cookieFrame: ElementRef;

    constructor(
        private settings: AppSettings,
        private cartService: CartService,
        private channelService: ChannelService,
        private authSevice: AuthService
    ) {
        super();
    }

    ngOnInit() {
        this.retrieveCartCount();
    }

    ngOnDestroy() {
        this.channelService.unbindConnectionMessage('realtimehub', 'CartCount', this.updateCartCount);
        super.ngOnDestroy();
    }

    retrieveCartCount(): void {
        if (this.authSevice.hasApplicationAccess && (this.settings.api.signalrIntegration === 'true')) {
            this.cartService.getCartItemCount()
                .pipe(pluck('result'))
                .subscribe(
                    result => this.cartCount = !!result && +result > 0 ? result.toString() : '',
                    err => console.log(err)
                );

            this.channelService.bindConnectionMessage('realtimehub', 'CartCount', this.updateCartCount);
        }
    }

    updateCartCount = (data) => {
        var tempCount = data.Result;
        if (tempCount > 0) {
            this.cartCount = tempCount;
        } else {
            this.cartCount = '';
        }
    };
}
